module.exports = __webpack_public_path__ + "videos/whatsnew-gradientmap_en.5ea3fc4.mp4";